<template>
	<div class="knd-audio" >
		<div class="knd-paragraaf">
		<div class="knd-play">
			<Toggle 
				:colorLinks='"#4E243F"'
				:colorRechts='"#4E243F"' 
				:value="!isMuted"
				:toggleFn='btnClick'>

			<template #links>
				geluid uit
			</template>
			
			<template #rechts>
				geluid aan
			</template>
			</Toggle>
			
			<ScrollObservable  
				:onEnter="(e) => onEnter(e, index)"
				:onExit="(e) => onExit(e, index)"
			>
				<div class="knd-subtitles-wrapper" ref="wrapper" :class="{active: hasPlayed}">
					<div v-for="(item, index) in data.audiosync" 
						:key="'audio-' + index" 
						:style="{'color': '#' + item.color}"
						class="knd-audio-line"
						:class="'size-' + item.size[0].titel">
						<div 
							class="knd-subtitles line subs" 
							v-if="item.jsonsync"  
							:ref="'subtitles-' + index"
						>
						</div>
						<div class="knd-subtitles" v-else>{{ item.quote }}</div>
					</div>
				</div>
		</ScrollObservable>
		</div>
	</div>
	</div>
</template>

<script>
// var syncData = [
// 	{"start": "0","text": "There" },
// 	{"start": "0.225","text": "were" },
// 	{"start": "0.485","text": "10 in" },
// 	{"start": "1.085","text": "his" },
// ];
// https://www.codepunker.com/resources/audio-sync-with-text/

import ScrollObservable from './ScrollObservable.vue';
import Toggle from '@/components/toggle';
import { mapGetters } from 'vuex'


export default {
	name: 'AudioParagraaf',
  props: ['data'],
	components:{ScrollObservable, Toggle},
  computed: {
    ...mapGetters({
      isMuted: 'getMuted'
    })
	},

	watch: {
		'$store.state.muted': function(newValue) {
			this.isMuted = newValue;
			this.audioPlayer.muted = this.isMuted;
		}

	},
	data() {
		return {
			audio: this.data.audio[0].url,
			hasPlayed: false,
			isPlaying: false,
			hasEnded: false,
			t: undefined,
			audiosync: undefined,
			jsonsync: undefined,
			syncArr: [],
			duration: 0,
			currentTime: 0,
		}
	},
	mounted: function() {
		this.init();

		if(this.data.audiosync) {

			this.data.audiosync.forEach((d, index) => {
				if(d.jsonsync){
					this.initSyncData(d, index);

					this.syncArr = [...this.syncArr, ...JSON.parse(d.jsonsync)];
				}
			});
		}
	},
	methods: {

		switchToggle() {
			
		},

		onEnter() {
			this.hasPlayed = true;

			this.play();
		},

		onExit() {
			this.pause();
		},

		simulateAudioPlayer() {
			if(this.t !== null) {
					//this.clearInterval();
				}

				this.t = setInterval(() => {
					this.currentTime += .25;
					var d = this.duration; //duration
					var pct = ((this.currentTime / d)*100);

					this.animate(this.currentTime);

					if(pct > 100){
						this.clearInterval();
						this.hasEnded = true;
						this.isPlaying = false;
						this.currentTime = 0;
					}
				},250);
		},

		clearInterval(){
			clearInterval(this.t);
			this.t = null;
		},

		animate(currentTime) {
			let elements = this.$refs.wrapper.querySelectorAll('.knd-word');
			
			this.syncArr.forEach((element, index) => {
				if(currentTime >= +element.start ) {
					elements[index].classList.add('active');
				}
			});
		},

		init() {
			this.audioPlayer = new Audio(process.env.VUE_APP_ASSETS + this.audio);

			this.audioPlayer.addEventListener("loadedmetadata", (e) => {
				this.duration = this.audioPlayer.duration;
			});

			this.audioPlayer.addEventListener("ended", (e) => {
				this.isPlaying = false;
				this.hasEnded = true;
			});

			this.audioPlayer.addEventListener("timeupdate", (e) => {
				this.currentTime = this.audioPlayer.currentTime;
				this.animate(this.currentTime);
			});

		},

		initSyncData(item, index) {
				let subtitles = this.$refs['subtitles' + '-' + index][0];
				let json = JSON.parse(item.jsonsync);
				this.createSubtitle(json, subtitles);
		},

		btnClick(e) {
			this.$store.dispatch("toggleSound");

			if(this.isPlaying)  {
				this.pause();
			}

			if(!this.isMuted) {
				this.reset();
				this.audioPlayer.play();
			}
			// e.preventDefault();
		},

		pause() {
			this.audioPlayer.pause();
			this.clearInterval();
		},

		play() {
			if(this.hasEnded) {
				const allElements = this.$refs.wrapper.querySelectorAll('.knd-word.active');
				
				allElements.forEach((element) => {
					element.classList.remove('active');
				});

				this.hasEnded = false;
			}

			if(this.isMuted) {
				this.simulateAudioPlayer();
			} else {
				this.audioPlayer.currentTime = this.currentTime;
				this.audioPlayer.play();
			}

		},

		reset() {
			const allElements = this.$refs.wrapper.querySelectorAll('.knd-word.active');

			this.pause();
			this.audioPlayer.currentTime = 0;

			allElements.forEach((element) => {
				element.classList.remove('active');
			});
			this.hasEnded = false;
		},
		
		createSubtitle(syncData, subtitles) {
			var element;
			for (var i = 0; i < syncData.length; i++) {
				element = document.createElement('span');
				element.setAttribute("id", "c_" + i);
				element.classList.add('knd-word')
				if(syncData[i].customClass) {
					element.classList.add(syncData[i].customClass)
				}
				element.innerText = syncData[i].text;
				subtitles.appendChild(element);

				let space = document.createElement('span');
				space.innerText = " "
				subtitles.appendChild(space);

			}
		}
	},
}
</script>

<style lang="scss">


	.knd-audio {
		position: relative;
		// height: 100vh;
		color: $pale-pistachio;
		font-family: $font-header;

		background: linear-gradient(180deg, #00deb2 0%, rgb(78, 36, 63) 100%);
		
		.size-lg {
			font-size: var(--audio-font-size-lg, 16px);
			font-weight: 200;
			margin-bottom: .5em;
		}

		.size-md {
			font-size: var(--audio-font-size-md, 16px);
			font-weight: 600;
			margin-bottom: .5em;
		}
	}

	.knd-toggle-container  {
		margin-bottom: 2em;

		.knd-optie {
			color: #4E243F;
		}
		.knd-toggle-button {
			border-color:#4E243F;
		}
	}

	.knd-subtitles-wrapper {
		opacity: 0;
		transform: translateY(50px);

		transition: opacity .3s linear, transform .3s ease-in-out;
		&.active {
			opacity: 1;
			transform: translateY(0);
		}
	}


	.knd-word {
			opacity: 0.4;
			transition: opacity .2s linear,transform .2s ease-in-out;
			&.active {
					opacity:1;

				&.knd-underline {
					text-decoration: underline;
				}

				&.knd-bold {
					font-weight: 500;
				}
			}
	}

	.knd-toggle {
		justify-content: center;
	}

	.knd-subtitles {
		text-align: center;
		line-height: 1.2em;
	}

</style>